module.exports = __webpack_public_path__ + "static/media/carolina-herrera-good-girl-glorious-gold-big.d6527fbb.png";